import React from 'react';
import { ReactComponent as WholeWorldExIcon } from '../../../../img/world_exc_icon.svg';
import { ReactComponent as WholeWorldIcon } from '../../../../img/world_icon.svg';
import { ReactComponent as SchengenIcon } from '../../../../img/schengen_icon.svg';
import UmberllaIcon from '../../../../img/umbrella.svg';

export default {
  schengen: {
    icon: <SchengenIcon />,
    sortLabel: '1',
  },
  whole_world_exc_uk_sch_us_ca_au_jp: {
    icon: <WholeWorldExIcon />,
    sortLabel: '2',
  },
  whole_world: {
    icon: <WholeWorldIcon />,
    sortLabel: '3',
  },
  ge: {
    icon: <img src={UmberllaIcon} style={{ width: 20, height: 20 }} alt="ge" />,
    sortLabel: '4',
  },
};
